import React, { useEffect } from "react";
import { useOutletContext } from "react-router";
import Button from "@Components/Button";
import AppBar from "@Components/AppBar";
import IconBanner from "@Components/IconBanner";
import IconButton from "@Components/IconButton";
import partyPopperImg from 'assets/images/party_popper.svg';
import { useBrowserHistory } from "@Utilities/services/hooks/useBrowserHistory";
import { logComponentEvent } from '@Utilities/services/logging/componentEvent';
import './styles/giftOccasion.scss';

export default function GiftOccasion() {
  const {
    localized,
    selectedOccasion,
    setSelectedOccasion,
    continueToDetails,
    occasionOptions,
    isGiftingOccasionEnabled
  } = useOutletContext();

  const browserHistory = useBrowserHistory();

  useEffect(() => {
    if (!isGiftingOccasionEnabled) {
      browserHistory.push('/gift');
    } else {
      logComponentEvent('GiftingOccasions', 'PageLoaded');
    }
  }, []);

  return isGiftingOccasionEnabled ? (
    <div className='gift-occasion'>
      <AppBar
        title={localized['giftOccasion.title'] || ''}
        onBackClick={() => {
          browserHistory.push('/gift');
        }}
        className='gift-occasion__toolbar'
        showBackButton
      />
      <IconBanner
        className='gift-occasion__banner'
        title={localized['giftOccasion.header'] || ''}
        description={localized['giftOccasion.body'] || ''}
        imgSrc={partyPopperImg}
        imgAlt={localized['giftOccasion.header.imgAlt']}
      />
      <div className='gift-occasion__content'>
        <section className='gift-occasion__content__list'>
          <h2 className='gift-occasion__content__list__heading'>
            {localized['giftOccasion.listHeader'] || ''}
          </h2>
          <div className='gift-occasion__content__list__container'>
            {occasionOptions && occasionOptions.map((occasion) => {
              return (
                <IconButton
                  key={occasion.value}
                  onClick={() => {
                    logComponentEvent(
                      'GiftingOccasions',
                      'OccasionClicked',
                      { data: { occasion: occasion.eventLabel }
                    });
                    setSelectedOccasion(occasion);
                  }}
                  className={
                    `gift-occasion__content__list__container__item${
                      selectedOccasion?.value === occasion?.value
                        ? ' gift-occasion__content__list__container__item--selected'
                        : ''
                      }
                    `
                  }
                >
                  <img className='gift-occasion__content__list__container__item__img' src={occasion.image} />
                  <span className='gift-occasion__content__list__container__item__label'>{occasion.label}</span>
                </IconButton>
              );
            })}
          </div>
        </section>
      </div>
      <Button
        size='large'
        variant='tonal'
        className='gift-occasion__btn'
        onClick={continueToDetails}
      >
        {localized['continue'] || ''}
      </Button>
    </div>
  ) : <></>;
}
